import { errorActions } from './error';
import { physicalFormatsConstants } from '../constants/physical_formats';
import { physicalFormatsService } from '../services/physical_formats';
import { physicalFormatsFormatter } from '../formatters/physical_formats';

export const physicalFormatsActions = {
	getPhysicalFormats
}

function getPhysicalFormats() {
	return ( dispatch, getState ) => {
		dispatch(request());
		physicalFormatsService.getPhysicalFormats()
		.then(
			physicalFormats => {
				physicalFormats = physicalFormatsFormatter.formatPhysicalFormats(physicalFormats.result);
				return dispatch(success(physicalFormats));
				
			}
		)
	};

	function request() { return { type: physicalFormatsConstants.GET_PHYSICAL_FORMATS_REQUEST } }
	function success(physicalFormats) { return { type: physicalFormatsConstants.GET_PHYSICAL_FORMATS_SUCCESS, physicalFormats } }
	function failure(error) { return { type: physicalFormatsConstants.GET_PHYSICAL_FORMATS_FAILURE, error } }
}
